import validate from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import custom_45redirect_45global from "/usr/src/app/middleware/customRedirect.global.ts";
import duplicate_45query_45param_45global from "/usr/src/app/middleware/duplicateQueryParam.global.ts";
import front_45end_45url_45redirect_45global from "/usr/src/app/middleware/frontEndUrlRedirect.global.ts";
import remove_45aspx_45route_45global from "/usr/src/app/middleware/removeAspxRoute.global.ts";
import user_45context_45global from "/usr/src/app/middleware/userContext.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  custom_45redirect_45global,
  duplicate_45query_45param_45global,
  front_45end_45url_45redirect_45global,
  remove_45aspx_45route_45global,
  user_45context_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/usr/src/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}